import request from '@/router/axios';

export const getList = (current, size, params) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/collect-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

export const getDetail = (id) => {
    return request({
        url: '/api/blade-loanPost/loanPost/detail',
        method: 'get',
        params: {
            id
        }
    })
}

export const remove = (ids) => {
    return request({
        url: '/api/blade-loanPost/loanPost/remove',
        method: 'post',
        params: {
            ids,
        }
    })
}

export const add = (row) => {
    return request({
        url: '/api/blade-loanPost/loanPost/submit',
        method: 'post',
        data: row
    })
}

export const update = (row) => {
    return request({
        url: '/api/blade-loanPost/loanPost/submit',
        method: 'post',
        data: row
    })
}


//actionPage
export const actionPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/actionPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//negotiationsPage
export const negotiationsPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/negotiationsPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//settlePage
export const settlePage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/settlePage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//distressedAssetPage
export const distressedAssetPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/distressedAssetPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//violationOfRegulationsPage
export const violationOfRegulationsPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/violationOfRegulationsPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//proceedingPage
export const proceedingPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/proceedingPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


///baseInfo
export const baseInfo = (loanPostId, loanInformationId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/baseInfo',
        url: '/api/v2/blade-loanPost/loan/baseInfo',
        method: 'post',
        data: {
            loanPostId,
            loanInformationId
        }
    })
}

//repaymentPlans
export const repaymentPlans = (loanPostId, repaymentType) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/repaymentPlans',
        url: '/api/v2/blade-loanPost/loan/repaymentPlans',
        method: 'post',
        data: {
            loanPostId,
            repaymentType
        }
    })
}


//collectionOperatorLog
export const collectionOperatorLog = (loanPostId) => {
    return request({
        url: '/api/blade-loanPost/loanPost/collectionOperatorLog',
        method: 'post',
        data: {
            loanPostId
        }
    })
}

//collect-enable-select-user-list
export const collectEnableSelectUserList = () => {
    return request({
        url: '/api/blade-loanPost/loanPost/collect-enable-select-user-listNew',
        method: 'get',
    })
}

//dept-collect-enable-select-user-list
export const deptCollectEnableSelectUserList = () => {
    return request({
        url: '/api/blade-loanPost/loanPost-dept/collect-enable-select-user-list',
        method: 'get',
    })
}


///collector-allocation-info
export const collectorAllocationInfo = (userId) => {
    return request({
        url: `/api/blade-loanPost/loanPost/collector-allocation-info?userId=${userId}`,
        method: 'post',
    })
}

///collector-allocation
export const collectorAllocation = (row) => {
    return request({
        url: '/api/blade-loanPost/loanPost/collector-allocation',
        method: 'post',
        data: row
    })
}


//collector-repayment-detail
export const collectorRepaymentDetail = (loanPostId, deptAction) => {
    return request({
        url: '/api/blade-loanPost/loanPost/collector-repayment-detail?loanPostId=' + loanPostId + '&deptAction=' + deptAction,
        // url: `/api/v2/blade-loanPost/loanPost-dept/dept-collector-repayment-deta?loanPostId=${loanPostId}`,
        method: 'get',
    })
}

//overdue-fee-details
export const overdueFeeDetails = (loanPostId) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/overdue-fee-details?loanPostId=' + loanPostId,
        url: '/api/v2/blade-loanPost/loan/overdue-fee-details?loanPostId=' + loanPostId,
        method: 'get',
    })
}


//treasurer-repayment-list
export const treasurerRepaymentList = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/treasurer-repayment-list',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//treasurer-repayment-detail
export const treasurerRepaymentDetail = (loanPostId) => {
    return request({
        url: '/api/blade-loanPost/loanPost/treasurer-repayment-detail?loanPostId=' + loanPostId,
        method: 'get',
    })
}

//dept treasurer-repayment-detail
export const deptTreasurerRepaymentDetail = (loanPostId) => {
    return request({
        url: '/api/blade-loanPost/loanPost-dept/treasurer-repayment-detail?loanPostId=' + loanPostId,
        method: 'get',
    })
}

//treasurer-repayment
export const treasurerRepayment = (row) => {
    return request({
        url: '/api/blade-loanPostOperatorData/loanPostOperatorData/treasurer-repayment',
        method: 'post',
        data: row
    })
}

//collector-repayment-records
export const collectorRepaymentRecords = (loanPostId) => {
    return request({
        url: `/api/blade-loanPost/loanPost/collector-repayment-records?loanPostId=${loanPostId}`,
        method: 'get',
    })
}

//insurancePage
export const insurancePage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/insurancePage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//gps-page
export const gpsPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/gps-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}




//getProceedingInfo
export const getProceedingInfo = (loanPostId) => {
    return request({
        url: '/api/blade-loanPost/loanPost/getProceedingInfo?loanPostId=' + loanPostId,
        method: 'get',
    })
}


//operatorLog
export const operatorLog = (loanPostId) => {
    return request({
        url: '/api/v2/blade-loanPost/loan/operatorLogLoan?type=web&loanPostId=' + loanPostId,
        method: 'get',
    })
}


//dept-collect-page
export const deptCollectPage = (current, size, params) => {
    return request({
        // url: '/api/v2/blade-loanPost/loanPost-dept/dept-collect-page',
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-collect-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//dept-action-page
export const deptActionPage = (current, size, params) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-action-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//dept-negotiations-page
export const deptNegotiationsPage = (current, size, params) => {
    return request({
        // url: '/api/blade-loanPost/loanPost-dept/dept-negotiations-page',
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-negotiations-page',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}


//action-enable-select-user-list
export const actionEnableSelectUserList = () => {
    return request({
        url: '/api/blade-loanPost/loanPost/action-enable-select-user-list',
        method: 'get',
    })
}

//dept-action-enable-select-user-list
export const deptActionEnableSelectUserListDept = () => {
    return request({
        // url: '/api/blade-loanPost/loanPost-dept/dept-action-enable-select-user-list',
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-action-enable-select-user-list',
        method: 'get',
    })
}


//negotiationsDetail
export const negotiationsDetail = (id) => {
    return request({
        url: '/api/blade-loanPost/loanPost/negotiationsDetail',
        method: 'get',
        params: {
            loanPostId: id
        }
    })
}

//settlementPage
export const settlementPage = (current, size, params) => {
    return request({
        url: '/api/blade-loanPost/loanPost/settlementPage',
        method: 'post',
        data: {
            ...params,
            current,
            size,
        }
    })
}

//settlementDetail
export const settlementDetail = (id) => {
    return request({
        url: '/api/blade-loanPost/loanPost/settlementDetail',
        method: 'get',
        params: {
            loanPostId: id
        }
    })
}


//treasurer-repayment-list
export const treasurerRepaymentListRecords = (loanPostId) => {
    return request({
        url: '/api/blade-loanPost/loanPost/treasurer-repayment-list-records',
        method: 'get',
        params: {
            loanPostId
        }
    })
}


export const collectDeptAdd = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/collect-add',
        method: 'post',
        data: row
    })
}

export const collectorRepaymentDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-collector-repayment',
        method: 'post',
        data: row
    })
}



export const collectHandoverDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/collect-handover',
        method: 'post',
        data: row
    })
}


export const customerRepaymentDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-customer-repayment',
        method: 'post',
        data: row
    })
}


export const newDeptCustomerRepayment = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loanPost-dept/new-dept-customer-repayment',
      method: 'post',
      data: row
  })
}



export const actionTrailerDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-actionTrailer',
        method: 'post',
        data: row
    })
}

export const actionTransferDept = (row) => {
    return request({
        url: '',
        method: 'post',
        data: row
    })
}

export const actionTransferChatDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-actionTransfer',
        method: 'post',
        data: row
    })
}

//negotiations
export const negotiationsDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-transfer',
        method: 'post',
        data: row
    })
}

//negotiationsTransfer
export const negotiationsTransferDept = (row) => {
    return request({
        url: '/api/v2/blade-loanPost/loanPost-dept/negotiationsTransfer',
        method: 'post',
        data: row
    })
}

//collector-repayment-detail
export const collectorRepaymentDeptDetail = (loanPostId, deptAction) => {
    return request({
        // url: '/api/blade-loanPost/loanPost/collector-repayment-detail?loanPostId=' + loanPostId + '&deptAction=' + deptAction,
        url: `/api/v2/blade-loanPost/loan/collector-repayment-detail?loanPostId=${loanPostId}&deptAction=${deptAction}`,
        method: 'get',
    })
}

//negotiationsUpdateOverdueFine
export const negotiationsUpdateOverdueFineDept = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/negotiationsUpdateOverdueFine',
        url: '/api/v2/blade-loanPost/loanPost-dept/dept-collector-update-overdue-fine',
        method: 'post',
        data: row
    })
}

//negotiationsUpdateLiquidatedDamagesAmount
export const negotiationsUpdateLiquidatedDamagesAmountDept = (row) => {
    return request({
        // url: '/api/blade-loanPostOperatorData/loanPostOperatorData/negotiationsUpdateLiquidatedDamagesAmount',
        url: '/api/v2/blade-loanPost/loanPost-dept/negotiationsUpdateLiquidatedDamagesAmount',
        method: 'post',
        data: row
    })
}

export const trailerPosition = (row) => {
  return request({
      url: '/api/v2/blade-loanPost/loan/trailer-position',
      method: 'post',
      data: row
  })
}
